module.exports = __webpack_public_path__ + "static/media/Bicycle Sports.fa1682c3.svg";